<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="800px"
    scrollable
    class="scrollDesign"
  >
    <v-card>
      <div class="_loading" v-show="loading">
        <v-progress-circular :size="50" color="primary" indeterminate />
        Cargando...
      </div>
      <div v-show="loading === false">
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Importar colaboradores</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-card-title
                class="headline lighten-2"
                primary-title
                style="text-align: center; justify-content: center"
              >
                Se cargaran los datos siguientes:
                <br />
              </v-card-title>
              <div class="box column_gap single_box">
                <div>
                  <h2 class="text_align-center">Colaboradores</h2>
                  <div class="box">
                    <p class="text_updates">
                      <v-icon class="icon_custom">chevron_right</v-icon>
                      <strong>{{ status.updated }}</strong>
                      {{
                        isSingle(status.updated)
                          ? TEXTS.updatedS
                          : TEXTS.updatedM
                      }}
                    </p>
                    <p class="text_updates">
                      <v-icon class="icon_custom">chevron_right</v-icon>
                      <strong>{{ status.removed }}</strong>
                      {{
                        isSingle(status.removed)
                          ? TEXTS.removedS
                          : TEXTS.removedM
                      }}
                    </p>
                    <p class="text_updates">
                      <v-icon class="icon_custom">chevron_right</v-icon>
                      <strong>{{ status.created }}</strong>
                      {{
                        isSingle(status.created)
                          ? TEXTS.createdS
                          : TEXTS.createdM
                      }}
                    </p>
                    <p class="text_updates">
                      <v-icon class="icon_custom">chevron_right</v-icon>
                      <strong>{{ status.ignored }}</strong>
                      {{
                        isSingle(status.ignored)
                          ? TEXTS.ignoredS
                          : TEXTS.ignoredM
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-card-text>
                <div class="text_align-center">
                  <strong> Importante: </strong>
                </div>
                <div class="text_align-center">
                  Recuerda que los datos serán remplazados con la información
                  nueva y no podrán recuperarse una vez que la carga este
                  completa.
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions style="justify-content: center">
                <v-btn
                  color="primary"
                  small
                  @click="close"
                  style="padding: 17px; margin: 17px"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="black"
                  small
                  @click="imput"
                  style="
                    padding: 17px;
                    margin: 17px;
                    color: white;
                    background: black;
                  "
                >
                  Cargar
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    status: { updated: 0, removed: 0, created: 0, ignored: 0 },
    TEXTS: {
      updatedS: 'Actualizado',
      updatedM: 'Actualizados',
      removedS: 'Baja',
      removedM: 'Bajas',
      createdS: 'Alta',
      createdM: 'Altas',
      ignoredS: 'Sin cambio',
      ignoredM: 'Sin cambios',
    },
  }),
  props: ['value', 'fileId'],
  methods: {
    async _getStatistics() {
      this.loading = true
      try {
        const response = await this.$store.dispatch(
          'employee/massiveUploadStatistics',
          this.fileId
        )
        // console.log(response)
        this.status = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    close() {
      this.$emit('input', !this.value)
    },

    imput() {
      this.$emit('input', !this.value)
      this.$emit('completeUpdateCollabs')
    },
    isSingle(val = 1) {
      return val === 1
    },
  },
  watch: {
    value() {
      if (this.value === true) {
        this._getStatistics()
      }
    },
  },
}
</script>

<style scoped>
._loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: 1;
  font-size: 17px;
  font-weight: 500;
  padding: 30px;
}
.column_gap {
  column-gap: 30px;
}
.box {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.single_box {
  grid-template-columns: repeat(1, 1fr);
}
.text_updates {
  display: flex;
  align-items: center;
}
.icon_custom {
  font-weight: bold;
  color: black;
}
.text_align-center {
  text-align: center;
}
.icon_custom + strong {
  margin-right: 5px;
}
h2.text_align-center {
  margin-bottom: 5px;
}
p.text_updates {
  margin-bottom: 5px;
}
</style>
